import script from "./AtlIndexComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AtlIndexComponent.vue?vue&type=script&setup=true&lang=js"

import "./AtlIndexComponent.vue?vue&type=style&index=0&id=06c2cd39&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c2cd39"]])

export default __exports__